import { API_URL, PROVIDERS_ME_URL } from '../../../../config';
import axios from 'axios';

export function uploadSinglePhoto(url, type, file) {
	const formData = new FormData();

	formData.append('file', file, file.name);
	formData.append('type', type);
	return axios.post(API_URL + url, formData);
}

export function deleteSinglePhoto(url, id) {
	return axios.delete(API_URL + url + '/' + id);
}

export function deleteLegalFile(id) {
	return axios.delete(PROVIDERS_ME_URL + '/legal-files/' + id);
}

export function updateProviderInfo(data) {
	return axios.put(PROVIDERS_ME_URL, data);
}

export function getProviderInfo() {
	return axios.get(PROVIDERS_ME_URL);
}

export function requestBusinessPlan(plan) {
	return axios.post(
		PROVIDERS_ME_URL + '/business-plan-request',
		plan ? { plan } : undefined
	);
}

export function requestBusinessPlanCancel() {
	return axios.post(PROVIDERS_ME_URL + '/business-plan-cancel-request');
}

export function getPlanData() {
	return axios.get(PROVIDERS_ME_URL + '/plan');
}

export function updateWhiteLabel(data) {
	return axios.put(PROVIDERS_ME_URL + '/white-label', data);
}
